import {Answer, Question} from "./models/Questions";
import PageTitle from "./PageTitle";

export default function QuestionPage(props: any) {

    let currentQuestion: Question = props.question;
    let selectAnswer: Function = props.selectAnswer;

    const answers = currentQuestion.answers.map((a, i) => (
    <div key={i} className="answers__text" onClick={() => selectAnswer(a)}>
        <label className="answers__text--container radio-button">
            <input checked={a.isChecked} onChange={() => selectAnswer(a)} type={currentQuestion.multiple ? "checkbox" : "radio"} value="В пределах МКАД" />
            <span className="check"></span>
            <div className="answer__text-inner">
                {a.text}
            </div>
        </label>
    </div>
    ));

    return (<div className="questionnaire__container">
        <div className="questionnaire__questions">
            <div className="questionnaire__questions-header">
                <PageTitle />
                <hr className="questionnaire__title-separator"></hr>
                <div className="title questionnaire__question-title">
                    <span>{currentQuestion.text}</span>
                </div>
                <div className="questionnaire__tags" style={{display: currentQuestion.multiple ? "flex" : "none"}}>
                    <span className="questionnaire__tag">
                        <div className="questionnaire__tag-icon">
                            <span className="icon">
                                <svg viewBox="0 0 24 24" className="mdi-icon mdi-16px">
                                    <title>mdi-check-circle</title>
                                    <path d="M12,2C17.52,2 22,6.48 22,12C22,17.52 17.52,22 12,22C6.48,22 2,17.52 2,12C2,6.48 6.48,2 12,2M11,16.5L18,9.5L16.59,8.09L11,13.67L7.91,10.59L6.5,12L11,16.5Z" stroke-width="0" fill-rule="nonzero"></path>
                                </svg>
                            </span>
                        </div>
                        <span className="questionnaire__tag-text">Выберите один или несколько</span>
                    </span>
                </div>
            </div>
        </div>
        <div className="questionnaire__question">
            <div className="answers">
                {answers}
            </div>
        </div>
    </div>);
}
